import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Checkout = styled.div`
  padding: 2px 16px 22px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${ColorPalette.HEX.White};
  border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
`;

export const ConfirmButton: any = styled(Button)`
  font-size: 16px;
  height: 56px;
  margin-top: 16px;
  & > span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

ConfirmButton.Label = styled.span`
  color: ${ColorPalette.HEX.White};
  font-size: 16px;
`;

export const ChurnContainer = styled.div`
  text-align: center;
`;

export const ChurnTitle = styled.h1`
  font-size: 20px;
  line-height: 24px;
  color: ${ColorPalette.HEX.PineTree2};
  text-align: center;
  max-width: 70%;
  margin: 0 auto 24px auto;
`;

export const ChurnDetail = styled.h2`
  font-size: 16px;
  color: ${ColorPalette.HEX.DimGray2};
  text-align: center;
  line-height: 22px;
  font-weight: normal;
  max-width: 90%;
  margin: 0 auto 40px auto;
`;

export const SupportAvatar = styled.img`
  width: 88px;
  height: auto;
  margin: 40px auto;
`;

export const CancelButton = styled.button`
  background: none;
  border: none;

  width: 100%;
  height: 50px;

  color: ${ColorPalette.HEX.PineTree};
  font-size: 16px;
  font-weight: bold;
  text-align: center;

  margin-top: 16px;
  cursor: pointer;
`;
